import { Component, computed, inject, input } from '@angular/core'
import { MatMenuItem } from '@angular/material/menu'
import { NavLinkDirective } from './nav-link.directive'
import { NavGroup } from '../routes'
import { AppLink, HomePageService } from './home-page.service'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-nav-group',
  imports: [NavLinkDirective, MatMenuItem, MatIcon],
  template: `
    @for (link of links(); track link.path) {
      <a mat-menu-item [navLink]="link.path">
        @if (link.favorite) {
          <mat-icon fontIcon='star' />
        }
        <span>{{ link.title }}</span>
      </a>
    }
  `,
  styles: `
    mat-icon {
      color: var(--bs-primary) !important;
      font-size: 18px !important;
      width: 20px !important;
      height: 20px !important;
      margin-right: 2px !important;
    }
  `,
})
export class NavGroupComponent {
  private readonly homePageService = inject(HomePageService)

  readonly group = input.required<NavGroup>()

  protected readonly links = computed((): readonly AppLink[] =>
    this.homePageService.getLinks(this.group()),
  )
}
